import { useEffect } from 'react';
import { useState } from 'react';

/**
 * Utility component to display a Promise value once it's resolved.
 */
export default function PromiseValue({
  promise,
}: {
  promise: React.ReactNode | Promise<React.ReactNode>;
}) {
  const [value, setValue] = useState<React.ReactNode | null>(
    promise instanceof Promise ? null : promise,
  );

  useEffect(() => {
    if (promise instanceof Promise) {
      promise.then(setValue);
    }
  }, [promise]);

  return value;
}
